<template>
  <div class="app flex-row align-items-center" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xl="7" md="8">
          <el-card class="box-card">
            <h3 class="text-center title">Khôi phục mật khẩu</h3>
            <b-alert
              variant="danger"
              dismissible
              :show="mData.dataDefault.showDismissibleAlert"
              @dismissed="mData.dataDefault.showDismissibleAlert = false"
              >{{ mData.dataDefault.error }}</b-alert
            >

            <el-form
              :model="mData.dataForm"
              :rules="mData.validForm"
              ref="myForm"
              label-width="100%"
              label-position="top"
              @submit.native.prevent
            >
              <el-form-item label="" prop="account">
                <el-input
                  autocomplete="new-password"
                  prefix-icon="el-icon-user"
                  v-model.trim="mData.dataForm.account"
                  clearable
                  disabled
                  placeholder="Tài khoản"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="code">
                <el-input
                  autocomplete="new-password"
                  prefix-icon="el-icon-key"
                  v-model.trim="mData.dataForm.code"
                  clearable
                  placeholder="Mã khôi phục"
                ></el-input>
              </el-form-item>
              <el-form-item label="" prop="pass">
                <el-input
                  autocomplete="new-password"
                  prefix-icon="el-icon-lock"
                  v-model.trim="mData.dataForm.pass"
                  :type="mData.dataShow.showPass === true ? 'text' : 'password'"
                  placeholder="Mật khẩu mới"
                >
                  <i
                    v-if="!mData.dataShow.showPass"
                    slot="suffix"
                    class="el-input__icon isax-eye-slash"
                    @click="mData.dataShow.showPass = true"
                  ></i>
                  <i
                    v-if="mData.dataShow.showPass"
                    slot="suffix"
                    class="el-input__icon isax-eye"
                    @click="mData.dataShow.showPass = false"
                  ></i>
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="repass">
                <el-input
                  autocomplete="off"
                  prefix-icon="el-icon-lock"
                  v-model.trim="mData.dataForm.repass"
                  :type="mData.dataShow.showRePass === true ? 'text' : 'password'"
                  placeholder="Nhập lại mật khẩu mới"
                >
                  <i
                    v-if="!mData.dataShow.showRePass"
                    slot="suffix"
                    class="el-input__icon isax-eye-slash"
                    @click="mData.dataShow.showRePass = true"
                  ></i>
                  <i
                    v-if="mData.dataShow.showRePass"
                    slot="suffix"
                    class="el-input__icon isax-eye"
                    @click="mData.dataShow.showRePass = false"
                  ></i>
                </el-input>
              </el-form-item>

              <el-form-item class="text-center">
                <el-button
                  type="primary"
                  @click="fn_submitForm()"
                  v-ladda
                  native-type="submit"
                  :disabled="disableButtonSubmit"
                  >Xác nhận</el-button
                >
              </el-form-item>
            </el-form>
            <b-col md="12" class="text-center mb-2" v-if="resendOTP === true">
              <span class="mr-2">Không nhận được mã khôi phục?</span>
              <b-link class="back-login" @click="resendOtpCode"
                >Gửi lại mã khôi phục</b-link
              >
            </b-col>
            <b-col md="12" class="text-center">
              <b-link class="back-login" to="/auth/login"
                >Quay lại trang đăng nhập</b-link
              >
            </b-col>
          </el-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import { store } from '../../store/store';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      resendOTP: false,
      disableButtonSubmit: false,
      mData: {
        dataShow: {
          showPass: false,
          showRePass: false,
        },
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          success: "",
          showDismissibleAlertSuccess: false,
          showDismissibleAlertMessage: false,
        },
        dataForm: {
          account: "",
          code: "",
          pass: "",
          repass: "",
        },
        validForm: {
          account: [ValidService.required],
          code: [ValidService.required],
          pass: [ValidService.required, ValidService.checkMinLength(6)],
          repass: [ValidService.required, ValidService.checkMinLength(6)],
        },
      },
    };
  },
  methods: {
    checkCoutWrongOtp(){
      let count = store.state.countEnterWrongOTP;
      if (count == 5) {
        this.disableButtonSubmit = true;
      }
    },
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          if (this.mData.dataForm.pass != this.mData.dataForm.repass) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Mật khẩu và nhập lại mật khẩu không khớp";
            MethodService.stopLadda();
            return;
          }
          AuthService.resetPassword(
            this.mData.dataForm.account,
            this.mData.dataForm.code,
            this.mData.dataForm.repass
          )
            .then((res) => {
              this.$message({
                showClose: true,
                message: "Đăng nhập bằng mật khẩu mới thành công",
                type: "success",
                duration: 6000, //8s
              });
              AuthService.login(this.mData.dataForm.account, this.mData.dataForm.repass)
                .then((res) => {
                  this.$router.push({ name: "Admin-Hello" });
                })
                .catch((error) => {
                  this.mData.dataDefault.showDismissibleAlert = true;
                  this.mData.dataDefault.error = "Đăng nhập không thành công";
                });
            })
            .catch((error) => {
              this.mData.dataDefault.showDismissibleAlert = true;
              store.commit("increaseCoutWrongOTP");
              this.checkCoutWrongOtp();
              this.mData.dataDefault.error = "Mã khôi phục không đúng. Vui lòng thử lại!";
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    showHideResendOTP() {
      this.resendOTP = !this.resendOTP;
    },
    resendOtpCode(){
      this.showHideResendOTP();
      AuthService.recoverPassword(this.mData.dataForm.account)
      .then((res) => {
        setTimeout(() => {
          this.showHideResendOTP();
        }, 60000);
      })
      .catch((error) => {console.log("error",error);})
    }
  },
  mounted: function () {
    if (this.$router.currentRoute.query.account) {
      this.mData.dataForm.account = this.$router.currentRoute.query.account;
      this.mData.dataDefault.showDismissibleAlertSuccess = true;
      this.mData.dataDefault.showDismissibleAlertMessage = true;
      this.mData.dataDefault.success =
        this.$router.currentRoute.params && this.$router.currentRoute.params.msg
          ? this.$router.currentRoute.params.msg
          : "";
    }
    setTimeout(() => {
      this.showHideResendOTP();
    }, 60000);
  },
};
</script>

<style scoped>
.title {
  text-transform: uppercase;
  margin-bottom: 5px;
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 53px;
  color: var(--orange_text);
  text-shadow: 0px 4px 20px rgba(1, 143, 255, 0.1);
}
.back-login {
  font-family: UTM Avo;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  text-decoration-line: underline;
  color: var(--orange_text) !important;
}
.alert-reset-pass-success p {
  margin-bottom: 0;
}
.alert-reset-pass .otp {
  line-height: 25px;
  margin-bottom: 0;
  color: black;
}
.alert-reset-pass .otp .otp-text {
  color: red;
  font-weight: bold;
  border: 1px solid;
  padding: 5px;
  border-radius: 15px;
}
.alert-reset-pass .otp .otp-title {
  margin-left: 5px;
  color: red;
  font-weight: bold;
}
.alert-reset-pass .otp .otp-image-web {
  width: 15%;
  transform: rotate(25deg);
}
::v-deep .el-card .el-card__body {
  padding: 25px;
}
::v-deep .el-input__suffix .el-input__icon {
  display: block;
  font-weight: 800;
  font-size: 22px !important;
  color: var(--orange);
  margin-top: 4px;
  margin-right: 6px;
}
</style>
